import './css/main.css';

import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router"

import Header from "./components/header"
import Footer from './components/footer';
import LandingPage from './components/pages/landingPage'
import ContactPage from './components/pages/contactPage';
import AboutPage from './components/pages/aboutPage';
import ReferencesPage from './components/pages/referencesPage';
import ServicesPage from './components/pages/servicesPage';
import OurworkPage from './components/pages/ourworkPage';


function App() {
  return (
    <BrowserRouter>
    <div className="App">

      <Header/>

      <Routes>
      <Route path="/contact" element={<ContactPage/>}/>
      <Route path="/references" element={<ReferencesPage/>}/>
      <Route path="/ourwork" element={<OurworkPage/>}/>
      <Route path="/services" element={<ServicesPage/>}/>
      <Route path="/about" element={<AboutPage/>}/>
      <Route path="/" element={<LandingPage/>}/>
      </Routes>

      <Footer/>
    </div>
    </BrowserRouter>
  );
}

export default App;
